import { PAGINATION_PAGE_SIZES } from '../../constants/pagination'

export function getOptions() {
  return PAGINATION_PAGE_SIZES.map(value => ({
    label: value.toString(),
    value,
  }))
}
